/**
 * Domain-Events (Phase 5) — Storage / Business-Payload.
 */

export const DOMAIN_EVENTS = {
  BUSINESS_PAYLOAD_UPDATED: 'business_payload_updated',
  SALE_COMPLETED: 'sale_completed',
  SALE_VOIDED: 'sale_voided',
  CUSTOMER_BALANCE_CHANGED: 'customer_balance_changed',
  SALES_UPDATED: 'sales_updated',
  PURCHASES_UPDATED: 'purchases_updated',
  INVENTORY_UPDATED: 'inventory_updated',
  CACHE_UPDATED: 'cache_updated',
  CUSTOMERS_UPDATED: 'customers_updated',
  PRODUCTS_UPDATED: 'products_updated',
  SUPPLIERS_UPDATED: 'suppliers_updated',
  ORDERS_UPDATED: 'orders_updated',
  DATA_CHANGED: 'data_changed',
  WORKER_SESSION_UPDATED: 'worker_session_updated',
  NOTIFICATION_RESOLVE: 'notification_resolve',
  ECART_UPDATED: 'ecart_updated',
  DEVIATION_NOTIFICATION: 'deviation_notification',
  STOCK_LOCATIONS_UPDATED: 'stock_locations_updated',
  BUSINESS_LOGO_UPDATED: 'business_logo_updated',
  /** Supplier finance facts — keep Bilan / Manager / Payment UI in sync */
  SUPPLIER_PAYMENT_RECORDED: 'supplier_payment_recorded',
  SUPPLIER_INVOICE_CHANGED: 'supplier_invoice_changed',
  /** Expense create/update — keep Dépense / Manager / Bilan in sync */
  EXPENSE_RECORDED: 'expense_recorded'
};
